import React from 'react'
import { graphql, Link } from 'gatsby'
import parse from 'html-react-parser'

import SEO from 'shared/Seo/Seo'
import Layout from 'shared/Layout/Layout'
import Paginations from 'shared/Pagination/Paginations'
import Random from 'main/Post/Random'
import LinkButton from 'shared/Button/LinkButton'

interface Datas {
  slug: string
  pageContext: any
  data: {
    allFlamelinkPostContent: {
      nodes: {
        slug: string
        title: string
        date: string
        snippet: string
        alt: string
        width: number
        height: number
        image: {
          url: string
        }[]
      }[]
    }
  }
}

const s = {
  container: `w-full h-fit-content`,
  wrapper: `mt-60 mx-0 mb-40 wrapper`,
  title: `-mt-4 mb-16`,

  grid: `grid-half gap-32 mdx:grid-cols-1 mdx:gap-36`,
  flex: `flex flex-col`,

  card: `grid-quater gap-8 items-center mb-20 xsx:grid-cols-1`,

  link: `w-full h-full mdm:h-80 smm:h-80 xsx:h-h32`,
  image: `w-full h-full object-cover`,

  body: `flex flex-col py-8 lgx:py-0`,
  subtitle: `-mt-2 mb-0 text-h3`,
  date: `mb-6 text-sm`,
  snippet: `mb-12 text-justify post`,
  button: `block w-fit ml-auto`,
}

const Posts = ({ pageContext, data }: Datas) => {
  const posts = data.allFlamelinkPostContent.nodes

  return (
    <section className={s.container}>
      <SEO title={`All news`} description={`More Rona news page...`} />
      <Layout backgrounds="bg-offwhite">
        <div className={s.wrapper}>
          <div className={s.grid}>
            <div className={s.flex}>
              <h2 className={s.title}>All News</h2>

              {posts.map(
                (
                  { slug, title, date, snippet, alt, width, height, image },
                  id
                ) => (
                  <div className={s.card} key={id}>
                    <Link className={s.link} to={`/post/${slug}/`}>
                      <img
                        className={s.image}
                        src={image[0].url}
                        alt={alt}
                        width={width}
                        height={height}
                      />
                    </Link>

                    <div className={s.body}>
                      <h3 className={s.subtitle}>{title}</h3>
                      <p className={s.date}>{date}</p>

                      <div className={s.snippet}>{parse(snippet)}</div>

                      <LinkButton classname={s.button} to={`/post/${slug}/`}>
                        Read News
                      </LinkButton>
                    </div>
                  </div>
                )
              )}

              <Paginations page={pageContext} />
            </div>
            <Random />
          </div>
        </div>
      </Layout>
    </section>
  )
}

export default Posts

export const query = graphql`
  query ($skip: Int!, $limit: Int!) {
    allFlamelinkPostContent(
      limit: $limit
      skip: $skip
      sort: { fields: date, order: DESC }
    ) {
      nodes {
        slug
        title
        date(formatString: "DD MMMM YYYY")
        snippet
        alt
        width
        height
        image {
          url
        }
      }
    }
  }
`
